module.exports = __webpack_public_path__ + "static/media/roberto.13824b16.jpeg";